import { myAxios } from "./helper";
import { getToken } from "./user-service";

export const createLinkToken = () => {
  let token = "Bearer " + getToken();

  return myAxios
    .get("/plaid/create-link-token", {
      headers: { authorization: token },
    })
    .then((response) => response.data);
};

export const createInvestmentLinkToken = () => {
  let token = "Bearer " + getToken();

  return myAxios
    .get("/plaid/create-investment-link-token", {
      headers: { authorization: token },
    })
    .then((response) => response.data);
};

export const exchangePublicToken = (publicToken) => {
  let token = "Bearer " + getToken();

  return myAxios
    .post(
      "/plaid/exchange-token",
      { public_token: publicToken },
      { headers: { authorization: token } }
    )
    .then((response) => response.data);
};

export const syncBank = (itemId) => {
  let token = "Bearer " + getToken();

  return myAxios
    .post(
      `/plaid/sync/${itemId}`,
      {},
      {
        headers: { authorization: token },
      }
    )
    .then((response) => response.data);
};